import { CSSObject } from '@chakra-ui/react';

export const BoxWrapper: CSSObject = { bg: 'transparent', h: 'full' };

export const ButtonDropdown: CSSObject = {
  border: 'none',
  bgGradient: 'linear(to-b, alpha.300, alpha.500)',
  color: 'alpha.900',
  boxShadow:
    '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  h: 'full',
  borderRadius: 'base',
  _hover: {
    bg: 'alpha.200',
    boxShadow:
      '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  },
};
export const BoxDropdown: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, alpha.300)',
  color: 'alpha.900',
  zIndex: 'docked',
  h: 'full',
  '.chakra-checkbox__label': {
    color: 'alpha.900',
  },
};
export const TextTitle: CSSObject = {
  color: 'alpha.900',
};
